




























































import Vue from "vue";
import { eventBus } from "@/utils/event";
export default Vue.extend({
  name: "Bread",
  data() {
    return {
      show4path: false,
      show5path: false,
      name: "",
      name5: "",
      callback: () => {
        //
      },
      callback2: () => {
        //
      }
    };
  },
  computed: {
    hidden() {
      return !this.$route.meta.isPrjMenu;
    }
  },
  watch: {
    "$route.name"() {
      this.show4path = false;
      this.show5path = false;
    }
  },
  mounted() {
    eventBus.$on("setBeard", this.setBeard);
  },
  methods: {
    setBeard({
      name,
      is4Path,
      callback
    }: {
      name: string;
      is4Path: boolean;
      callback: () => void;
    }) {
      if (this.show4path && !is4Path) {
        // 第五层
        this.show5path = true;
        this.name5 = name;
        if (callback) {
          this.callback2 = callback;
        }
      } else {
        // 第四层
        this.show4path = true;
        this.name = name;

        if (callback) {
          this.callback = callback;
        }
      }
    },
    breadClick() {
      this.callback();

      this.$nextTick(() => {
        this.show4path = false;
        this.show5path = false;
        this.name = "";
        this.name5 = "";
        this.callback = () => {
          //
        };
        this.callback2 = () => {
          //
        };
      });
    },
    breadClick2() {
      this.callback2();

      this.$nextTick(() => {
        this.show5path = false;
        this.name5 = "";
        this.callback2 = () => {
          //
        };
      });
    }
  }
});
